import TeenTopOpenPage from "./TeenTopOpenPage";

export default function TeenPatti41() {
  return <TeenTopOpenPage gameType="teen41" title="Queen Top Open Teenpatti" />;
}
